import { useEffect, useState } from 'react';
import Header from '../components/Header.jsx';
import { fmtElapsed, fmtTime, roundSignOutHour } from '../lib/datetime.js';

export default function ActiveSessionScreen({ device, session, onSignOut, onEditCathayId }) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((x) => x + 1), 1000);
    return () => clearInterval(t);
  }, []);
  // tick variable triggers re-renders so the elapsed clock + slot range update.
  void tick;

  // Slot range — start was rounded at signin time and persists; the end
  // expands as the pilot crosses 30-min sign-out rounding boundaries.
  // E.g. signin 08:55 → start=09, baseline end=10. Past 10:30 the
  // pilot's CURRENT sign-out would round to 11:00, so display 09:00–11:00.
  const slotStartHour = session?.signin_rounded_hour
    ? new Date(session.signin_rounded_hour).getHours()
    : null;
  const liveEndHour =
    slotStartHour != null
      ? Math.max(slotStartHour + 1, roundSignOutHour(new Date()))
      : null;
  const slotLabel =
    slotStartHour != null && liveEndHour != null
      ? `${String(slotStartHour).padStart(2, '0')}:00 – ${String(liveEndHour).padStart(2, '0')}:00`
      : null;

  return (
    <div className="min-h-screen flex flex-col bg-slate-100">
      <Header deviceName={device?.name} />
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-xl bg-white rounded-3xl shadow-xl p-8 space-y-6 text-center">
          <div className="inline-block bg-green-100 text-green-800 text-kiosk-lg font-semibold rounded-full px-6 py-2">
            Session active
          </div>

          <div>
            <div className="text-kiosk text-slate-500">Signed in at</div>
            <div className="font-mono text-kiosk-xl text-cathay-700 mt-1">
              {session?.signin_at_utc ? fmtTime(session.signin_at_utc) : '—'}
            </div>
          </div>

          {slotLabel && (
            <div>
              <div className="text-kiosk text-slate-500">Currently signed in for slot</div>
              <div className="font-mono text-kiosk-lg text-slate-800 mt-1">{slotLabel}</div>
            </div>
          )}

          <div>
            <div className="text-kiosk text-slate-500">Elapsed</div>
            <div className="font-mono text-kiosk-xl text-slate-800 mt-1">
              {fmtElapsed(session?.signin_at_utc)}
            </div>
          </div>

          <div className="border-t border-slate-100 pt-4">
            <div className="text-kiosk text-slate-500">CathayID</div>
            <div className="font-mono text-kiosk-lg text-slate-800 mt-1">
              {session?.cathay_id_entered}
            </div>
            <button
              type="button"
              onClick={onEditCathayId}
              className="mt-2 text-kiosk text-cathay-700 underline"
            >
              Wrong CathayID? Fix it
            </button>
          </div>

          <button
            type="button"
            onClick={onSignOut}
            className="w-full bg-cathay-500 hover:bg-cathay-600 active:bg-cathay-700 text-white text-kiosk-lg font-semibold py-6 rounded-2xl shadow"
          >
            Sign out
          </button>
        </div>
      </main>
    </div>
  );
}
